import React, { useState } from "react";
import { connect } from "react-redux";
import * as actionCreator from "../../../../action/index.js";
import { Checkbox } from "@rmwc/checkbox";
import EditPriceItem from "../../../EditPriceItem/EditPriceItem";
import { Select } from "@rmwc/select";
import { Radio } from "@rmwc/radio";
import CurrencyFormat from "react-currency-format";
import { params, const_var } from "../../../../redux/reducers/reducer.js";
import SideJTrimPrice from "../SideJTrimPrice.js";
import EndJTrimPrice from "../EndJTrimPrice.js";
import Dropdown from "react-bootstrap/Dropdown";
import { calcNumOfWalls } from "../../../../helpers/building_pricing/wall_pricing/wallPricing.helper.js";


const DropDefaultToggle = React.forwardRef(({ children, onClick }, ref) => (
	<a
		href=""
		className="drop-default-toggle"
		ref={ref}
		onClick={(e) => {
			e.preventDefault();
			onClick(e);
		}}
	>
		{children}
	</a>
));

const DropItemInfo = ({ label, priceNode, actionClassName, children }) => (
	<div className="drop-item-info">
		<div className="drop-text">
			<div className="drop-label">{label}</div>
			{priceNode}
		</div>
		<div className={actionClassName}>{children}</div>
	</div>
);

const PriceDisplay = ({ loginSession, hide_price_calculation, post_data, price, jsonObjKey, isDisabled = "false", updatedPriceDataObj, wrapperClassName = "price-box", show = true }) => {
	if (!show || post_data?.building == undefined) return null;

	if (loginSession == true) {
		return (
			<div className={wrapperClassName}>
				<EditPriceItem updatedPriceDataObj={updatedPriceDataObj} is_disabled={isDisabled} jsonObj={post_data.building[jsonObjKey] ?? 0} jsonObjKey={jsonObjKey} />
			</div>
		);
	}

	if (hide_price_calculation !== 1 && price !== undefined && price !== 0) {
		return (
			<div className="price-box-type-2">
				<CurrencyFormat value={price} displayType="text" thousandSeparator prefix="$" />
			</div>
		);
	}

	return null;
};

const ExtraItemPriceDisplay = ({ loginSession, post_data, isChecked, jsonObjKey, jsonObjValue, updatedPriceDataObj, fallback }) => {
	if (loginSession == true && isChecked) {
		if (post_data?.building == undefined) return null;
		return (
			<div className="price-box">
				<EditPriceItem updatedPriceDataObj={updatedPriceDataObj} is_disabled={isChecked ? "false" : "true"} jsonObj="extraitems" jsonObjValue={jsonObjValue} jsonObjKey={jsonObjKey} />
			</div>
		);
	}
	return fallback ?? null;
};

const WallDropdown = ({ toggleDropdown, displayText, wallArray, currentValue, isCutPanel, isBreezeway, onChange, priceNode }) => (
	<Dropdown className="drop-default" onToggle={() => toggleDropdown()}>
		<Dropdown.Toggle as={DropDefaultToggle}>
			<span className="text">{displayText}</span>
			<i className="icon icon-arrow-down-ico" />
		</Dropdown.Toggle>
		<Dropdown.Menu className="drop-menu-default" align="right">
			<ul className="drop-list-default">
				{Object.entries(wallArray).map(([key, value], index) => {
					const isHalfPanel = key.includes("1/2 Panel");
					const isChecked = isBreezeway ? "Open" : isHalfPanel ? currentValue == value && isCutPanel : currentValue == value && !isCutPanel;
					const isSelected = isHalfPanel ? value == currentValue && isCutPanel : currentValue == value && !isCutPanel;
					return (
						<li className="drop-list-item" key={index}>
							<div className="radio-group">
								<Radio onChange={onChange} label={key} checked={isChecked} value={value} />
								{isSelected && priceNode}
							</div>
						</li>
					);
				})}
			</ul>
		</Dropdown.Menu>
	</Dropdown>
);

const SimpleWallDropdown = ({ toggleDropdown, displayText, wallArray, currentValue, isBreezeway, onChange, priceNode }) => (
	<Dropdown className="drop-default" onToggle={() => toggleDropdown()}>
		<Dropdown.Toggle as={DropDefaultToggle}>
			<span className="text">{displayText}</span>
			<i className="icon icon-arrow-down-ico" />
		</Dropdown.Toggle>
		<Dropdown.Menu className="drop-menu-default" align="right">
			<ul className="drop-list-default">
				{Object.entries(wallArray).map(([key, value], index) => (
					<li className="drop-list-item" key={index}>
						<div className="radio-group">
							<Radio onChange={onChange} label={key} checked={!isBreezeway ? currentValue == value : "Open"} value={value} />
							{currentValue == value && priceNode}
						</div>
					</li>
				))}
			</ul>
		</Dropdown.Menu>
	</Dropdown>
);

const StorageLengthDropdown = ({ toggleDropdown, feetValue, options, checkedValue, onChange, priceNode }) => (
	<Dropdown className="drop-default" onToggle={() => toggleDropdown()}>
		<Dropdown.Toggle as={DropDefaultToggle}>
			<span className="text">{feetValue} Feet</span>
			<i className="icon icon-arrow-down-ico" />
		</Dropdown.Toggle>
		<Dropdown.Menu className="drop-menu-default" align="right">
			<ul className="drop-list-default">
				{Object.entries(options).map(([key, value]) => (
					<li className="drop-list-item" key={key}>
						<div className="radio-group">
							<Radio onChange={onChange} checked={checkedValue == value} label={key} value={value} />
							{checkedValue == value && priceNode}
						</div>
					</li>
				))}
			</ul>
		</Dropdown.Menu>
	</Dropdown>
);

// ─── Main Component ───────────────────────────────────────────────────────────
const CenterWall = (props) => {
	const [selectedItem, setSelectedItem] = useState(null);
	const [dropdownOpen, setDropdownOpen] = useState(false);
	const [dropdownId, setDropdownId] = useState("");
	const { loginSession, hide_price_calculation, post_data, holdPricingResponse } = props.const_var;
	const priceProps = { loginSession, hide_price_calculation, post_data };
	const setName = (selname, selArray, cutPanel) => {
		if (cutPanel == undefined) {
			const name = Object.entries(selArray).find(([, val]) => val == selname);
			return name?.[0];
		}
		const name = cutPanel ? Object.entries(selArray).find(([key, val]) => val == selname && key.includes("1/2 Panel")) : Object.entries(selArray).find(([, val]) => val == selname);
		return name?.[0];
	};
	const storageLength = (e, val, combo) => {
		if (props.const_var.is_loader == false) {
			props.handleUtilityLenghtSelectonChangeValue(e, val);
			if (combo == "center") props.getPricingData("false");
			if (combo == "left_combo") props.getPricingDataforUtility(e.target.value, "left_combo", e.target.value);
			if (combo == "right_combo") props.getPricingDataforUtility(e.target.value, "right_combo", e.target.value);
		}
	};
	const commonFunctionForOpenWall = (e) => {
		props.toggleFullyOpenedCheckboxChange(e.target.value, "openCenterBuldingWalls");
	};

	const { toggleDropdown } = props;
	let isJtrimSide = false;
	let isJtrim = false;
	let chkEndJtrim = false;
	let chkSideJtrim = false;
	let EndJtrim_checkedDefault = false;
	let SideJtrim_checkedDefault = false;
	let chkSideJtrimNew = false;
	let checkSideWall = false;

	const totalSideWall = calcNumOfWalls("side", "1");
	const totalEndWall = calcNumOfWalls("end", "1");
	const cb_a_p_d_a = structuredClone(holdPricingResponse);
	if (cb_a_p_d_a.jtrim?.length > 0) {
		chkEndJtrim = cb_a_p_d_a.jtrim.filter((data) => data.type == "end");
		if (chkEndJtrim.length > 0) {
			if (chkEndJtrim[0].is_jtrim !== undefined && chkEndJtrim[0].is_jtrim == "included") {
				EndJtrim_checkedDefault = true;
			}
			chkEndJtrim = true;
		}
		chkSideJtrimNew = cb_a_p_d_a.jtrim.filter((data) => data.type == "side");
		chkSideJtrim = chkSideJtrimNew.length > 0;
	}

	if (chkSideJtrim == true && totalSideWall != 0) {
		isJtrimSide = true;
		checkSideWall = true;
	}
	if (chkEndJtrim == true && totalEndWall != 0) {
		isJtrim = true;
	}
	if ((chkSideJtrim == true && props.params.p_c_p_l == true) || props.params.p_c_p_r == true) {
		isJtrimSide = true;
	}

	if (isJtrimSide == true && chkSideJtrimNew.length > 0) {
		if (chkSideJtrimNew.filter((data) => data.is_panel_jtrim != undefined).length > 0) {
			if (props.params.p_c_p_l == true || props.params.p_c_p_r == true) {
				if (checkSideWall == true) {
					if (chkSideJtrimNew.filter((data) => data.is_cut_panel_jtrim == "included" || data.is_panel_jtrim == "included").length > 0) {
						SideJtrim_checkedDefault = true;
					}
				} else {
					if (chkSideJtrimNew.filter((data) => data.is_cut_panel_jtrim == "included").length > 0) {
						SideJtrim_checkedDefault = true;
					}
				}
			} else {
				if (chkSideJtrimNew.filter((data) => data.is_panel_jtrim == "included").length > 0) {
					SideJtrim_checkedDefault = true;
				}
			}
		}
	}

	const utilityPriceNode = <PriceDisplay {...priceProps} price={post_data?.building?.utility_price} jsonObjKey="utility_price" show={props.params.p_u_c} />;
	const leftStoragePriceNode = <PriceDisplay {...priceProps} price={post_data?.building?.utility_price} jsonObjKey="utility_price" show={props.params.cB_addStorage_check_left} />;
	const rightStoragePriceNode = <PriceDisplay {...priceProps} price={post_data?.building?.utility_price} jsonObjKey="utility_price" show={props.params.cB_addStorage_check_right} />;

	return (
		<>
			<div>
				{!props.params.isBreezeway && (
					<>
						{/* ── Wall Options ── */}
						<div className="form-group-md">
							<div className="control-label-bar justify-content-between">
								<label className="control-label">Walls</label>
							</div>

							<div className="radio-group">
								<Radio label="Open" value="openwall" name="openwall" checked={props.const_var.setSidesEndsWallOption == "open"} onClick={commonFunctionForOpenWall} />
							</div>

							<div className="control-field-bar">
								<div className="control-field">
									<div className="radio-group">
										<Radio
											label="Fully Enclosed"
											value="fully_enclosed"
											name="fully_enclosed"
											checked={props.const_var.setSidesEndsWallOption == "close"}
											onClick={(e) => props.toggleFullyEnclosedCheckboxChange(e.target.value, "closeCenterBuldingWalls")}
										/>
									</div>
								</div>
							</div>

							<div className="radio-group">
								<Radio
									label="Custom"
									value="Custom"
									name="fully_enclosed"
									checked={props.const_var.setSidesEndsWallOption == "partial"}
									onClick={() => props.toggleCustomCheckboxChange("centerBuilding")}
								/>
							</div>
						</div>

						{/* ── Custom Wall Dropdowns ── */}
						{props.const_var.setSidesEndsWallOption == "partial" && (
							<div className="drop-info">
								{/* Front */}
								<DropItemInfo
									label="Front"
									priceNode={
										<PriceDisplay
											{...priceProps}
											price={post_data?.building?.front_wall_price}
											jsonObjKey="front_wall_price"
											isDisabled={props.params.p_f_w == "Open" ? "true" : "false"}
											show={props.params.p_f_w !== "Open"}
										/>
									}
									actionClassName={params.p_u_c && params.endStoragePositionZ == params.p_d - params.p_u_t && !props.params.isBreezeway ? "drop-action disabled" : "drop-action"}
								>
									<SimpleWallDropdown
										toggleDropdown={toggleDropdown}
										displayText={setName(props.params.p_f_w, const_var.wallArray["front"])}
										wallArray={const_var.wallArray["front"]}
										currentValue={props.params.p_f_w}
										isBreezeway={props.params.isBreezeway}
										onChange={(e) => props.handleWallSelectonChangeValue(e, "front")}
										priceNode={
											<PriceDisplay
												{...priceProps}
												price={post_data?.building?.front_wall_price}
												jsonObjKey="front_wall_price"
												isDisabled={props.params.p_f_w == "Open" ? "true" : "false"}
												show={props.params.p_f_w !== "Open"}
											/>
										}
									/>
								</DropItemInfo>

								{/* Back */}
								<DropItemInfo
									label="Back"
									priceNode={
										<PriceDisplay
											{...priceProps}
											price={post_data?.building?.back_wall_price}
											jsonObjKey="back_wall_price"
											isDisabled={props.params.p_b_w == "Open" ? "true" : "false"}
											show={props.params.p_b_w !== "Open"}
										/>
									}
									actionClassName={params.p_u_c && params.endStoragePositionZ == 0 && !props.params.isBreezeway ? "drop-action disabled" : "drop-action"}
								>
									<SimpleWallDropdown
										toggleDropdown={toggleDropdown}
										displayText={setName(props.params.p_b_w, const_var.wallArray["back"])}
										wallArray={const_var.wallArray["back"]}
										currentValue={props.params.p_b_w}
										isBreezeway={props.params.isBreezeway}
										onChange={(e) => props.handleWallSelectonChangeValue(e, "back")}
										priceNode={
											<PriceDisplay
												{...priceProps}
												price={post_data?.building?.back_wall_price}
												jsonObjKey="back_wall_price"
												isDisabled={props.params.p_b_w == "Open" ? "true" : "false"}
												show={props.params.p_b_w !== "Open"}
											/>
										}
									/>
								</DropItemInfo>

								{/* Left */}
								<DropItemInfo
									label="Left"
									priceNode={
										<PriceDisplay
											{...priceProps}
											price={post_data?.building?.left_wall_price}
											jsonObjKey="left_wall_price"
											isDisabled={params.cB_addStorage_check_left !== true ? "false" : "true"}
											show={params.p_l_w !== "Open" || props.params.p_c_p_l}
										/>
									}
									actionClassName={params.cB_addStorage_check_left == true ? "drop-action disabled" : "drop-action"}
								>
									<WallDropdown
										toggleDropdown={toggleDropdown}
										displayText={params.cB_addStorage_check_left == true ? "Closed" : setName(props.params.p_l_w, props.jsonDataL, props.params.p_c_p_l)}
										wallArray={props.jsonDataL}
										currentValue={props.params.p_l_w}
										isCutPanel={props.params.p_c_p_l}
										isBreezeway={props.params.isBreezeway}
										onChange={(e) => props.handleWallSelectonChangeValue(e, "left")}
										priceNode={
											<PriceDisplay
												{...priceProps}
												price={post_data?.building?.left_wall_price}
												jsonObjKey="left_wall_price"
												isDisabled={params.cB_addStorage_check_left !== true ? "false" : "true"}
												show={true}
											/>
										}
									/>
								</DropItemInfo>

								{/* Right */}
								<DropItemInfo
									label="Right"
									priceNode={
										<PriceDisplay
											{...priceProps}
											price={post_data?.building?.right_wall_price}
											jsonObjKey="right_wall_price"
											isDisabled={params.cB_addStorage_check_right !== true ? "false" : "true"}
											show={params.p_r_w !== "Open" || props.params.p_c_p_r}
										/>
									}
									actionClassName={params.cB_addStorage_check_right == true ? "drop-action disabled" : "drop-action"}
								>
									<WallDropdown
										toggleDropdown={toggleDropdown}
										displayText={params.cB_addStorage_check_right == true ? "Closed" : setName(props.params.p_r_w, props.jsonDataR, props.params.p_c_p_r)}
										wallArray={props.jsonDataR}
										currentValue={props.params.p_r_w}
										isCutPanel={props.params.p_c_p_r}
										isBreezeway={props.params.isBreezeway}
										onChange={(e) => props.handleWallSelectonChangeValue(e, "right")}
										priceNode={
											<PriceDisplay
												{...priceProps}
												price={post_data?.building?.right_wall_price}
												jsonObjKey="right_wall_price"
												isDisabled={params.cB_addStorage_check_right !== true ? "false" : "true"}
												show={true}
											/>
										}
									/>
								</DropItemInfo>
							</div>
						)}

						{/* ── J-Trim ── */}
						<div className="form-group">
							{cb_a_p_d_a.jtrim?.length > 0 && (isJtrim || isJtrimSide) && <label className="control-label">J-Trim</label>}
							{/* End J-Trim */}
							{cb_a_p_d_a.jtrim?.length > 0 &&
							isJtrim &&
							((props.params.p_f_w !== "Half Dutch End" && props.params.p_f_w !== "Half End") || (props.params.p_b_w != "Half Dutch End" && props.params.p_b_w != "Half End")) ? (
								<div className="row">
									<div className="col">
										<div className="radio-group">
											<Checkbox
												label={EndJtrim_checkedDefault && props.params.p_j_t_end ? "End J Trim (Included)" : "End J Trim"}
												name="end_jtrim"
												checked={props.params.p_j_t_end}
												disabled={EndJtrim_checkedDefault}
												onChange={(e) => props.extraItemsAction(e.target.value, "end_jtrim")}
											/>
											<ExtraItemPriceDisplay
												loginSession={loginSession}
												post_data={post_data}
												isChecked={props.params.p_j_t_end}
												jsonObjKey="End Jtrim"
												jsonObjValue={props.params.p_j_t_end}
												updatedPriceDataObj={const_var.lNTBuildingData["updatePriceDataElements"]["centerBuilding"]}
												fallback={EndJtrim_checkedDefault !== true ? <EndJTrimPrice /> : null}
											/>
										</div>
									</div>
								</div>
							) : null}

							{/* Side J-Trim */}
							{cb_a_p_d_a.jtrim?.length > 0 && isJtrimSide && (
								<div className="row">
									<div className="col">
										<div className="radio-group">
											<Checkbox
												label={SideJtrim_checkedDefault && props.params.p_j_t ? "Side J Trim (Included)" : "Side J Trim"}
												name="jtrim"
												checked={props.params.p_j_t}
												disabled={SideJtrim_checkedDefault}
												onChange={(e) => props.extraItemsAction(e.target.value, "jtrim")}
											/>
											<ExtraItemPriceDisplay
												loginSession={loginSession}
												post_data={post_data}
												isChecked={props.params.p_j_t}
												jsonObjKey="Jtrim"
												jsonObjValue={props.params.p_j_t}
												updatedPriceDataObj={const_var.lNTBuildingData["updatePriceDataElements"]["centerBuilding"]}
												fallback={SideJtrim_checkedDefault !== true ? <SideJTrimPrice /> : null}
											/>
										</div>
									</div>
								</div>
							)}
						</div>
					</>
				)}

				{/* ── Breezeway Section ── */}
				{props.params.isBreezeway && (
					<>
						<div className="form-group">
							<label className="control-label">Breezeway Length</label>
							<div className="floating-label-input">
								<Select
									ripple="RipplePropF"
									value={props.const_var.breezewayLength}
									onChange={(e) => {
										props.handleBreezawayFrameAndStorages(e.target.value, "frameout");
										props.getPricingData("false");
									}}
									options={const_var.breezewayFrameoutOptions?.map((o) => ({ value: o.value, label: o.label }))}
								/>
							</div>
						</div>

						<div className="row align-items-center mb-3">
							<div className="col-6">
								<div className="floating-label-input">
									<Checkbox
										label="Front Storage"
										value={props.params.isBreezeway}
										name="openwall1"
										disabled={props.params.isBreezeway}
										checked={props.params.isBreezeway}
										onChange={(e) => props.handleBreezawayFrameAndStorages(e.target.value, "frontStorageCheckbox")}
									/>
								</div>
							</div>

							{post_data?.building != undefined && props.params.isBreezeway && loginSession == true && (
								<div className="col-6 text-right">
									<div className="price-box">
										<EditPriceItem jsonObj={post_data.building.utility_front_price} jsonObjKey="utility_front_price" />
									</div>
								</div>
							)}

							<div className="col-12 mt-1">
								<div className="floating-label-input floating-label-inside border-0">
									<Select
										onChange={(e) => {
											props.handleBreezawayFrameAndStorages(e.target.value, "frontStorageLength");
											props.getPricingData("false");
										}}
										value={props.params.cB_addStorage_front}
										className="cpanelselect"
										label="Front Utility Enclosed Area"
										options={Object.entries(const_var.breezewayFrontStorageOptions).map(([key, value]) => ({ value, label: key }))}
									/>
								</div>
							</div>
						</div>

						<div className="row align-items-center">
							<div className="col-6">
								<div className="floating-label-input floating-label-inside border-0">
									<Checkbox
										label="Back Storage"
										value={props.params.isBreezeway}
										name="openwall1"
										disabled={props.params.isBreezeway}
										checked={props.params.isBreezeway}
										onChange={(e) => props.handleBreezawayFrameAndStorages(e.target.value, "backStorageCheckbox")}
									/>
								</div>
							</div>

							{post_data?.building != undefined && props.params.isBreezeway && (
								<div className="col-6 text-right">
									<div className="price-box">
										<EditPriceItem jsonObj={post_data.building.utility_price} jsonObjKey="utility_price" />
									</div>
								</div>
							)}

							<div className="col-12 mt-1">
								<div className="floating-label-input">
									<Select
										onChange={(e) => {
											props.handleBreezawayFrameAndStorages(e.target.value, "backStorageLength");
											props.getPricingData("false");
										}}
										value={props.params.p_u_t}
										className="cpanelselect"
										label="Back Utility Enclosed Area"
										options={Object.entries(props.const_var.breezewayBackStorageOptions).map(([key, value]) => ({ value, label: key }))}
									/>
								</div>
							</div>
						</div>
					</>
				)}

				{/* ── Storage Section ── */}
				{!props.params.isBreezeway && (
					<div className="form-group">
						<div className="control-label">Storage</div>

						{/* None */}
						<div className="row">
							<div className="col-6">
								<div className="radio-group">
									<Radio
										label="None"
										disabled={(params.isBreezeway && (params.p_u_c || params.cB_addStorage_check_front)) || props.const_var.is_loader}
										checked={props.params.nostorage}
										name="openwall4"
										onChange={(e) => props.nostorage(e.target.value, props.params.nostorage)}
									/>
								</div>
							</div>
						</div>

						{/* End Storage */}
						<div className="row justify-content-between">
							<div className={Object.keys(props.const_var.b_u_D_p_a).length > 0 ? "col" : "col disabled"}>
								<div className="radio-group">
									<Radio
										label={
											post_data?.building?.utility_position != undefined && post_data.building.utility_position !== 0
												? `Storage (${Math.round(post_data.building.utility_position)}' from Back)`
												: "End Storage"
										}
										disabled={props.const_var.is_loader}
										value={props.params.p_u_c}
										name="openwall1"
										checked={props.params.p_u_c}
										onChange={(e) => props.toggleAddUtilityCheckboxChange(e, "back", "backStorage")}
									/>
									{utilityPriceNode}
								</div>
							</div>

							<div className="col-auto text-right">
								{props.params.p_u_c && !props.params.isBreezeway && (
									<StorageLengthDropdown
										toggleDropdown={toggleDropdown}
										feetValue={props.params.p_u_t}
										options={props.const_var.b_u_D_p_a}
										checkedValue={props.params.p_u_t}
										onChange={(e) => storageLength(e, "center", "center")}
										priceNode={utilityPriceNode}
									/>
								)}
							</div>
						</div>

						{/* Left Storage */}
						<div className="row justify-content-between">
							<div className="col">
								<div className="radio-group">
									<Radio
										label="Left Storage"
										checked={props.params.cB_addStorage_check_left}
										name="openwall2"
										disabled={(params.isBreezeway && (params.p_u_c || params.cB_addStorage_check_front)) || props.const_var.is_loader}
										onChange={(e) => props.toggleAddUtilityCheckboxChange(e, "left", props.params.cB_addStorage_left)}
									/>
									{leftStoragePriceNode}
								</div>
							</div>
							<div className="col-auto text-right">
								{props.params.cB_addStorage_check_left && (
									<StorageLengthDropdown
										toggleDropdown={toggleDropdown}
										feetValue={props.params.cB_addStorage_left}
										options={props.const_var.b_u_D_p_a_c_b}
										checkedValue={props.params.cB_addStorage_left}
										onChange={(e) => storageLength(e, "centerLeft", "left_combo")}
										priceNode={leftStoragePriceNode}
									/>
								)}
							</div>
						</div>

						{/* Right Storage */}
						<div className="row justify-content-between">
							<div className="col">
								<div className="radio-group">
									<Radio
										label="Right Storage"
										disabled={(params.isBreezeway && (params.p_u_c || params.cB_addStorage_check_front)) || props.const_var.is_loader}
										checked={props.params.cB_addStorage_check_right}
										name="openwall3"
										onChange={(e) => props.toggleAddUtilityCheckboxChange(e, "right", props.params.cB_addStorage_right)}
									/>
									{rightStoragePriceNode}
								</div>
							</div>
							<div className="col-auto text-right">
								{props.params.cB_addStorage_check_right && (
									<StorageLengthDropdown
										toggleDropdown={toggleDropdown}
										feetValue={props.params.cB_addStorage_right}
										options={props.const_var.b_u_D_p_a_c_b}
										checkedValue={props.params.cB_addStorage_right}
										onChange={(e) => storageLength(e, "centerRight", "right_combo")}
										priceNode={rightStoragePriceNode}
									/>
								)}
							</div>
						</div>

						<div className="row d-none">
							<div className="col-6">
								<div className="radio-group">
									<Radio
										label="Both Side Storages"
										checked={props.params.cB_addStorage_check_both}
										name="openwall2"
										disabled={(params.isBreezeway && (params.p_u_c || params.cB_addStorage_check_front)) || props.const_var.is_loader}
										onChange={(e) => props.toggleAddUtilityCheckboxChange(e, "both", "")}
									/>
								</div>
							</div>
						</div>

						<div className="row d-none">
							<div className="col-6">
								<div className="radio-group">
									<Radio
										label="Both Side + Back Storages"
										checked={props.params.cB_addStorage_check_both}
										name="openwall2"
										disabled={(params.isBreezeway && (params.p_u_c || params.cB_addStorage_check_front)) || props.const_var.is_loader}
										onChange={(e) => props.toggleAddUtilityCheckboxChange(e, "bothside_with_back", "")}
									/>
								</div>
							</div>
						</div>
					</div>
				)}
			</div>
		</>
	);
};

const mapStoreToProps = (state) => state.reducer;

export default connect(mapStoreToProps, actionCreator)(CenterWall);
